import React, { useState } from 'react'
import { formatDateRequire, onlyNumeric } from '../../../../components/commonClass/CommonValidation';
import { CustomModal } from '../../../../customControl/CustomModal';
import ColumnsDevider from '../../../../customControl/ColumnsDevider';
import { postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { ClearLocalStorage } from '../../../../components/commonClass/Session';
import { loaderActions } from '../../../../_actions/loader.actions';
import { useDispatch } from 'react-redux';

const FlightBookingRefundPopup = (props: any) => {
    const { flightData, show, setShow, getbookingdatalist } = props;
    const dispatch = useDispatch();
    const [formErrors, setFormErrors] = useState<any>({});
    const [formValue, setFormValue] = useState({
        BookingId: flightData?.[0]?.BookingId,
        RefundDetails: flightData?.map((el: any) => ({
            PartialTicketCancelId: el?.PartialTicketCancelId,
            RefundAmount: null
        })) || []
    });

    const handleChange = (index: number, value: any) => {
        setFormErrors({})
        setFormValue((prev) => ({
            ...prev,
            RefundDetails: prev.RefundDetails.map((item: any, i: any) =>
                i === index ? { ...item, RefundAmount: value?.length > 0 ? Number(value) : null } : item
            )
        }));
    };

    const validateData = () => {
        let status: boolean = true;
        const error: any = {}
        formValue?.RefundDetails?.map((el: any, index: any) => {
            if (el?.RefundAmount === null) {
                error[`RefundAmount${index}`] = "Please enter refund amount.";
                status = false;
            }
        })

        setFormErrors(error);
        return status;
    }

    const handlesave = async () => {
        if (validateData()) {
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                const res = await postUsersData('/midoffice/v1/updatepartialcancellationdetails', formValue)
                if (res?.status) {
                    getbookingdatalist()
                    dispatch(loaderActions.end());
                    setShow(false)
                }
                else {
                    dispatch({ type: 'ALERTING', message: res?.message })
                    dispatch(loaderActions.end());
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
            dispatch(loaderActions.end());
        }
    }

    const modlabodyfilter = () => {
        return (
            <div className="modal-body px-0 refund_modal">
                {flightData?.map((obj: any, mainindex: number) => (
                    <div className={`${mainindex > 0 ? 'mt-2' : ''}`}>
                        <div className="accordion" id="accordionPanelsStayOpenExample">
                            <div className="accordion-item">
                                <h2 className="accordion-header" id={`panelsStayOpen-headingOne${mainindex}`}>
                                    <button className={`accordion-button ${mainindex > 0 ? 'collapsed' : ''}`} type="button" data-bs-toggle="collapse" data-bs-target={`#panelsStayOpen-collapseOne${mainindex}`} aria-expanded="true" aria-controls={`panelsStayOpen-collapseOne${mainindex}`}>
                                        <div className='row w-100'>
                                            <div className='col-6 fw-bold'>
                                                {obj?.FullName}&nbsp;({obj?.PaxType === 1 ? 'Adult' : obj?.PaxType === 2 ? 'Child' : obj?.PaxType === 3 ? 'Infant' : ''})
                                            </div>
                                            <div className='col-6 fw-bold'>
                                                {obj?.Origin}&nbsp;-&nbsp;{obj?.Destination}
                                            </div>
                                        </div>
                                    </button>
                                </h2>
                                <div id={`panelsStayOpen-collapseOne${mainindex}`} className={`accordion-collapse collapse my-2 ${mainindex > 0 ? '' : 'show'}`} aria-labelledby={`panelsStayOpen-headingOne${mainindex}`}>
                                    <div className="accordion-body">
                                        <div className='row'>
                                            <ColumnsDevider label='Date of Cancellation'>
                                                <input type="text" className="form-control mb-1"
                                                    defaultValue={obj?.CancellationDate && formatDateRequire(obj?.CancellationDate)}
                                                    disabled placeholder="Date of Cancellation" />
                                            </ColumnsDevider>
                                            <ColumnsDevider label='Time of Cancellation'>
                                                <input type="text" className="form-control mb-1"
                                                    defaultValue={obj?.CancellationTime}
                                                    disabled placeholder="Time of Cancellation" />
                                            </ColumnsDevider>
                                            <ColumnsDevider label='PNR'>
                                                <input type="text" className="form-control mb-1"
                                                    defaultValue={obj?.PNR}
                                                    disabled placeholder="PNR" />
                                            </ColumnsDevider>
                                            <ColumnsDevider label='Refund Amount' isRequired>
                                                <input type="text" className="form-control mb-1"
                                                    value={(formValue?.RefundDetails?.[mainindex]?.RefundAmount)?.toString() || ''}
                                                    maxLength={6}
                                                    onChange={(e: any) => handleChange(mainindex, onlyNumeric(e?.target?.value))}
                                                    placeholder="Refund Amount" />
                                                {formErrors[`RefundAmount${mainindex}`] && <div className='text-danger text-start fs_14'>{formErrors[`RefundAmount${mainindex}`]}</div>}
                                            </ColumnsDevider>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
                <div className='mt-3 d-flex justify-content-center'>
                    <button type="button" className="btn btn-primary" onClick={handlesave} id="btnSearch">Save</button>
                </div>
            </div>
        )
    }


    return (
        <>
            <CustomModal
                {...props}
                show={show}
                size='xl'
                onHide={() => setShow(false)}
                modaltitle='Refund Detail'
                modalbody={modlabodyfilter}
                modalfooter=''
            />
        </>
    )
}

export default FlightBookingRefundPopup